import Close from './close';
import { MarkdownHtml as Markdown } from '@bit/evidation.sdf1.studies.form-elements';
import Modal from 'styled-react-modal';
import React from 'react';
import styled from 'styled-components';

const TopRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 0;
`;
const CloseButton = styled.button`
  cursor: pointer;
  background: transparent;
  position: relative;
  top: -15px;
  left: 20px;
`;

const StyledModal = Modal.styled`
    background-color: white;
    opacity: ${props => props.opacity};
    transition: opacity ease 200ms;
`;

const Content = styled.div`
  font-weight: 300;
  background: #fff;
  max-width: 472px;
  padding: 40px;

  & > * {
    padding-bottom: 15px;
  }

  & > :last-child,
  & > :first-child {
    padding-bottom: 0;
  }
`;

const Title = styled.div``;

const Info = styled.div`
  p {
    color: #5b6b7d;
    text-align: center;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

const MainSection = styled.div`
  max-width: 376px;
`;

const BasicStyledModal = ({
  isOpen,
  afterOpen,
  beforeClose,
  closeModal,
  opacity,
  children,
  title,
  content,
}) => (
  <React.Fragment>
    <StyledModal
      isOpen={isOpen}
      afterOpen={afterOpen}
      beforeClose={beforeClose}
      onBackgroundClick={closeModal}
      onEscapeKeydown={closeModal}
      opacity={opacity}
    >
      <Content>
        <TopRight>
          <CloseButton onClick={closeModal}>
            <Close />
          </CloseButton>
        </TopRight>
        <Title>
          <h1>{title}</h1>
        </Title>
        <Info>
          <Markdown>{content}</Markdown>
        </Info>
        <MainSection>{children}</MainSection>
      </Content>
    </StyledModal>
  </React.Fragment>
);

export default BasicStyledModal;



// WEBPACK FOOTER //
// ./src/components/styledModal.js